export function generateErrorMessage (message: any, optionalMessage: string) {
    if (typeof(message) === 'string' && message !== '') return message
    return optionalMessage
}